import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found — Orvella Overseas" description="The page you are looking for could not be found." path="/404" />
      <section className="container-x flex min-h-[60vh] flex-col items-center justify-center py-24 text-center" data-testid="not-found-page">
        <span className="font-serif text-7xl font-semibold text-gold-soft">404</span>
        <h1 className="mt-4 font-serif text-3xl font-semibold text-navy">This page could not be found</h1>
        <p className="mt-3 max-w-md text-sm text-mist">
          The link may be outdated. Explore our product portfolio or contact our export team with your requirement.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-navy">Back to Home</Link>
          <Link to="/products" className="btn-outline">Explore Products</Link>
        </div>
      </section>
    </>
  );
}
